
<div
  class="cmp-property-slider"
  :class="{
    applied: propApplied,
  }"
>
  <template v-if="inEdit">
    <ws-checkbox v-model="propApplied" class="text-bold" full-width>
      <template v-slot>
        <price-period
          v-if="propPrice"
          class="float-right"
          plain
          :price="propPrice.actualPrice"
          :between="model.volume ? '' : '/GB'"
          :period="propPrice.period"
          individual
        />
        <small
          v-if="label"
          class="checkbox-label"
          :class="propApplied ? 'text-ws-base150' : 'text-ws-base110'"
        >{{ $t(label) }}</small>
      </template>
    </ws-checkbox>

    <ws-slider
      v-if="propApplied"
      v-model="model.volume"
      label-always
      position="bottom"
      :disable="!propApplied"
      :config="propConfig"
      @input="reEmit({ ...model, volume: $event })"
    />
  </template>
  <template v-else>
    <price-period
      class="float-right"
      :price="propPrice.actualPrice"
      :period="propPrice.period"
      individual
    />
    <span v-if="label" class="text-ws-base150">{{ $t(label) }}</span>
  </template>
</div>
